module.exports = __webpack_public_path__ + "static/undraw_file_analysis_8k9b-826923aa45b1b83b1dbc0ac8408fc77c.svg";